const Shared = require("Sources/shared");
const Utils = require("Sources/utils/utils");
const DialogTemplate = require("Sources/templates/dialog.template");
const LanguageManager = require("Sources/services/language-manager");

const campaignVideoNl = require("Video/campaign_nl.mp4");
const campaignVideoFr = require("Video/campaign_fr.mp4");
const sowVideoNl = require("Video/tray_nl.mp4");
const sowVideoFr = require("Video/tray_fr.mp4");
const barnVideoNl = require("Video/barn_nl.mp4");
const barnVideoFr = require("Video/barn_fr.mp4");

require("Styles/pages/videos.scss");

$(function()
{
  Shared.init();
  VideosPage.init();
});

var VideosPage = {};

((VideosPage) =>
{
  VideosPage.init = function()
  {
    Utils.ImageSVGToSVG();

    var campaignVid;
    var sowVid;
    var barnVid;


    if(LanguageManager.getCurrentLocale() === "nl-BE")
    {
      campaignVid =  {src: campaignVideoNl};
      sowVid =  {src: sowVideoNl};
      barnVid =  {src: barnVideoNl};
    }
    else if(LanguageManager.getCurrentLocale() === "fr-BE")
    {
      campaignVid =  {src: campaignVideoFr};
      sowVid =  {src: sowVideoFr};
      barnVid =  {src: barnVideoFr};
    }


    $("#video-campaign-video").on("click", campaignVid, startVideo);
    $("#video-sow-video").on("click", sowVid, startVideo);
    $("#video-barn-video").on("click", barnVid, startVideo);


    if(window.location.hash === "#campaign")
    {
      startVideo({data: campaignVid});
    }
    else if(window.location.hash === "#sow")
    {
      startVideo({data: sowVid});
    }
    else if(window.location.hash === "#barn")
    {
      startVideo({data: barnVid});
    }
  };

  function startVideo(event)
  {
    var content = $("<div class='embed-responsive embed-responsive-16by9'></div>");
    var closeBtn = require("Images/video_page/btn_close.png");
    var $closeBtn = $("<button class='btn btn-close video-close-btn' type='button'><img src='" + closeBtn + "'/></button>");
    content.append($closeBtn);
    content.append("<video controls autoplay src='" + event.data.src + "' class='embed-responsive-item'></video>");

    var videoDialog = new DialogTemplate({
      dialogId: "video-dialog",
      dialogContent: content,
      disposable: true,
      onConfirm: function()
      {
        videoDialog.destroy();
      },
      onCancel: function()
      {
        videoDialog.destroy();
      }

    });

    $closeBtn.on("click", function(e)
    {
      videoDialog.cancel();
    });

    videoDialog.show();
  }
})(VideosPage);



// WEBPACK FOOTER //
// ./app/js/entries/videos.js